webpackJsonp([37,40],{

/***/ 133:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MimicAmpImg_vue__ = __webpack_require__(455);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7e0f36de_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MimicAmpImg_vue__ = __webpack_require__(461);
function injectStyle (ssrContext) {
  __webpack_require__(459)
}
var normalizeComponent = __webpack_require__(20)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7e0f36de"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MimicAmpImg_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7e0f36de_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MimicAmpImg_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 139:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MimicAmpCarousel_vue__ = __webpack_require__(736);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_51eb047e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MimicAmpCarousel_vue__ = __webpack_require__(783);
function injectStyle (ssrContext) {
  __webpack_require__(781)
}
var normalizeComponent = __webpack_require__(20)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-51eb047e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MimicAmpCarousel_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_51eb047e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MimicAmpCarousel_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)


/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 455:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'mimic-amp-img',
  props: ['image']
});

/***/ }),

/***/ 459:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(460);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(342)("2434fe00", content, true, {});

/***/ }),

/***/ 460:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(341)(true);
// imports


// module
exports.push([module.i, ".amp-img[data-v-7e0f36de]{display:block;width:100%;position:relative;overflow:hidden!important}.amp-img-sizer[data-v-7e0f36de]{display:block!important}.amp-img-content[data-v-7e0f36de]{display:block;margin:auto;border:none!important;padding:0!important;width:0;max-width:100%;min-width:100%;height:0;max-height:100%;min-height:100%;position:absolute;top:0;left:0;right:0;bottom:0}", "", {"version":3,"sources":["/Users/yuki/Public/wp-admin/src/components/mimic-amp/MimicAmpImg.vue"],"names":[],"mappings":"AAsBA,0BACE,cAAe,AACf,WAAY,AACZ,kBAAmB,AACnB,yBAA4B,CAC7B,AACD,gCACI,uBAA0B,CAC7B,AACD,kCACI,cAAe,AACf,YAAa,AACb,sBAAwB,AACxB,oBAAsB,AACtB,QAAS,AACT,eAAgB,AAChB,eAAgB,AAChB,SAAU,AACV,gBAAiB,AACjB,gBAAiB,AACjB,kBAAmB,AACnB,MAAO,AACP,OAAQ,AACR,QAAS,AACT,QAAU,CACb","file":"MimicAmpImg.vue","sourcesContent":["/**\n *\n * Layout\n *\n */\n/**\n * Columns\n */\n/**\n * Component\n */\n/**\n *\n * Application specific variables\n *\n */\n/* Transition\n-------------------------- */\n/* Colors\n-------------------------- */\n/* Menu\n--------------------------*/\n.amp-img[data-v-7e0f36de] {\n  display: block;\n  width: 100%;\n  position: relative;\n  overflow: hidden !important;\n}\n.amp-img-sizer[data-v-7e0f36de] {\n    display: block !important;\n}\n.amp-img-content[data-v-7e0f36de] {\n    display: block;\n    margin: auto;\n    border: none !important;\n    padding: 0 !important;\n    width: 0;\n    max-width: 100%;\n    min-width: 100%;\n    height: 0;\n    max-height: 100%;\n    min-height: 100%;\n    position: absolute;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 461:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"amp-img"},[_c('div',{staticClass:"amp-img-sizer",style:('padding-top:' + _vm.image.height / _vm.image.width * 100 + '%')}),_vm._v(" "),_c('img',{staticClass:"amp-img-content",attrs:{"src":_vm.image.src}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 736:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__MimicAmpImg__ = __webpack_require__(133);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'mimic-amp-carousel',
  components: {
    'mimic-amp-img': __WEBPACK_IMPORTED_MODULE_0__MimicAmpImg__["default"]
  },
  props: ['images', 'delay'],
  data: function data() {
    return {
      timerId: null,
      orders: [],
      isSet: true
    };
  },
  methods: {
    updateOrders: function updateOrders() {
      var _this = this;

      this.orders = this.images.map(function (image, i) {
        return (i + 1) % _this.images.length + 1;
      });
    }
  },
  watch: {
    images: function images(newVal, oldVal) {
      this.updateOrders();
    },
    delay: function delay(newVal, oldVal) {
      var _this2 = this;

      if (this.delay < 1000) return;
      clearInterval(this.timerId);
      this.timerId = setInterval(function () {
        _this2.orders.unshift(_this2.orders.splice(_this2.orders.length - 1, 1));
        _this2.isSet = false;
        setTimeout(function () {
          _this2.isSet = true;
        }, 50);
      }, this.delay);
    }
  },
  created: function created() {
    this.updateOrders();
  },
  mounted: function mounted() {
    var _this3 = this;

    this.timerId = setInterval(function () {
      _this3.orders.unshift(_this3.orders.splice(_this3.orders.length - 1, 1));
      _this3.isSet = false;
      setTimeout(function () {
        _this3.isSet = true;
      }, 50);
    }, this.delay);
  },
  beforeDestroy: function beforeDestroy() {
    clearInterval(this.timerId);
  }
});

/***/ }),

/***/ 781:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(782);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(342)("5c406652", content, true, {});

/***/ }),

/***/ 782:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(341)(true);
// imports


// module
exports.push([module.i, ".amp-carousel[data-v-51eb047e]{overflow:hidden;position:relative}.amp-carousel-slide-container[data-v-51eb047e]{display:-webkit-box;display:-ms-flexbox;display:flex;-ms-flex-wrap:nowrap;flex-wrap:nowrap;-webkit-box-sizing:content-box;box-sizing:content-box;padding-bottom:20px;width:100%;height:100%;position:absolute;top:0;left:0;left:-100%;-webkit-transform:translateX(100%);transform:translateX(100%);-webkit-scroll-snap-type:mandatory;-ms-scroll-snap-type:mandatory;scroll-snap-type:mandatory}.amp-carousel-slide-container.is-set[data-v-51eb047e]{-webkit-transform:none;transform:none;-webkit-transition:-webkit-transform .5s cubic-bezier(.23,1,.32,1);transition:-webkit-transform .5s cubic-bezier(.23,1,.32,1);transition:transform .5s cubic-bezier(.23,1,.32,1);transition:transform .5s cubic-bezier(.23,1,.32,1),-webkit-transform .5s cubic-bezier(.23,1,.32,1)}.amp-carousel-item[data-v-51eb047e]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-flex:0;-ms-flex:0 0 100%;flex:0 0 100%;width:100%;height:100%;position:relative;-webkit-scroll-snap-coordinate:0 0;-ms-scroll-snap-coordinate:0 0;scroll-snap-coordinate:0 0}.amp-carousel-item>[data-v-51eb047e]{width:100%;height:100%;overflow:hidden}.component-warning[data-v-51eb047e]{padding:5em 0;background-color:#fafafa}.component-warning-span[data-v-51eb047e]{color:red}", "", {"version":3,"sources":["/Users/yuki/Public/wp-admin/src/components/mimic-amp/MimicAmpCarousel.vue"],"names":[],"mappings":"AAsBA,+BACE,gBAAiB,AACjB,iBAAmB,CACpB,AACD,+CACI,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,qBAAsB,AAClB,iBAAkB,AACtB,+BAAgC,AACxB,uBAAwB,AAChC,oBAAqB,AACrB,WAAY,AACZ,YAAa,AACb,kBAAmB,AACnB,MAAO,AACP,OAAQ,AACR,WAAY,AACZ,mCAAoC,AAC5B,2BAA4B,AACpC,mCAAoC,AAChC,+BAAgC,AAC5B,0BAA4B,CACvC,AACD,sDACM,uBAAwB,AAChB,eAAgB,AACxB,mEAA2E,AAC3E,2DAAmE,AACnE,mDAA2D,AAC3D,kGAAmH,CACxH,AACD,oCACI,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,wBAAyB,AACrB,qBAAsB,AAClB,uBAAwB,AAChC,yBAA0B,AACtB,sBAAuB,AACnB,mBAAoB,AAC5B,mBAAoB,AAChB,kBAAmB,AACf,cAAe,AACvB,WAAY,AACZ,YAAa,AACb,kBAAmB,AACnB,mCAAoC,AAChC,+BAAgC,AAC5B,0BAA4B,CACvC,AACD,qCACM,WAAY,AACZ,YAAa,AACb,eAAiB,CACtB,AACD,oCACE,cAAe,AACf,wBAA0B,CAC3B,AACD,yCACI,SAAW,CACd","file":"MimicAmpCarousel.vue","sourcesContent":["/**\n *\n * Layout\n *\n */\n/**\n * Columns\n */\n/**\n * Component\n */\n/**\n *\n * Application specific variables\n *\n */\n/* Transition\n-------------------------- */\n/* Colors\n-------------------------- */\n/* Menu\n--------------------------*/\n.amp-carousel[data-v-51eb047e] {\n  overflow: hidden;\n  position: relative;\n}\n.amp-carousel-slide-container[data-v-51eb047e] {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -ms-flex-wrap: nowrap;\n        flex-wrap: nowrap;\n    -webkit-box-sizing: content-box;\n            box-sizing: content-box;\n    padding-bottom: 20px;\n    width: 100%;\n    height: 100%;\n    position: absolute;\n    top: 0;\n    left: 0;\n    left: -100%;\n    -webkit-transform: translateX(100%);\n            transform: translateX(100%);\n    -webkit-scroll-snap-type: mandatory;\n        -ms-scroll-snap-type: mandatory;\n            scroll-snap-type: mandatory;\n}\n.amp-carousel-slide-container.is-set[data-v-51eb047e] {\n      -webkit-transform: none;\n              transform: none;\n      -webkit-transition: -webkit-transform 500ms cubic-bezier(0.23, 1, 0.32, 1);\n      transition: -webkit-transform 500ms cubic-bezier(0.23, 1, 0.32, 1);\n      transition: transform 500ms cubic-bezier(0.23, 1, 0.32, 1);\n      transition: transform 500ms cubic-bezier(0.23, 1, 0.32, 1), -webkit-transform 500ms cubic-bezier(0.23, 1, 0.32, 1);\n}\n.amp-carousel-item[data-v-51eb047e] {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-pack: center;\n        -ms-flex-pack: center;\n            justify-content: center;\n    -webkit-box-align: center;\n        -ms-flex-align: center;\n            align-items: center;\n    -webkit-box-flex: 0;\n        -ms-flex: 0 0 100%;\n            flex: 0 0 100%;\n    width: 100%;\n    height: 100%;\n    position: relative;\n    -webkit-scroll-snap-coordinate: 0 0;\n        -ms-scroll-snap-coordinate: 0 0;\n            scroll-snap-coordinate: 0 0;\n}\n.amp-carousel-item > *[data-v-51eb047e] {\n      width: 100%;\n      height: 100%;\n      overflow: hidden;\n}\n.component-warning[data-v-51eb047e] {\n  padding: 5em 0;\n  background-color: #fafafa;\n}\n.component-warning-span[data-v-51eb047e] {\n    color: red;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 783:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.images.length > 2)?[_c('div',{staticClass:"amp-carousel theme-base-bg-color"},[_c('div',{staticClass:"amp-img-sizer",style:('padding-top:' + _vm.images[0].height / _vm.images[0].width * 100 + '%')}),_vm._v(" "),_c('div',{class:['amp-carousel-slide-container', _vm.isSet ? 'is-set' : '']},[_vm._l((_vm.images),function(image,i){return [_c('div',{staticClass:"amp-carousel-item",style:('order: ' + _vm.orders[i])},[_c('mimic-amp-img',{attrs:{"image":image}})],1)]})],2)])]:(_vm.images.length === 0)?[_vm._m(0)]:[_vm._m(1)]],2)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"component-warning flex justify-center items-center"},[_c('span',{staticClass:"component-warning-span"},[_vm._v("カルーセル用の画像が選択されていません")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"component-warning flex justify-center items-center"},[_c('span',{staticClass:"component-warning-span"},[_vm._v("カルーセルのために３枚以上の画像を選択してください")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })

});


// WEBPACK FOOTER //
// static/js/37.275b2cb3312255d69afb.js